import { createSlice } from "@reduxjs/toolkit";

import { EquipmentState } from "redux/states/EquipmentState";
import { getAllEquipment } from "redux/actions/equipmentActions";

const initialState: EquipmentState = {
  allEquipment: [],
  allEquipmentLoadingState: "NotLoaded",
};

const EquipmentSlice = createSlice({
  name: "EquipmentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllEquipment.pending, (state) => {
        state.allEquipmentLoadingState = "Loading";
      })
      .addCase(getAllEquipment.fulfilled, (state, action) => {
        state.allEquipmentLoadingState = "Loaded";
        state.allEquipment = action.payload;
      })
      .addCase(getAllEquipment.rejected, (state) => {
        state.allEquipmentLoadingState = "Failed";
      });
  },
});

export default EquipmentSlice.reducer;
